/**
 * GA4 User Tracking Component
 * Automatically initializes Google Analytics user_id tracking for authenticated users
  */

"use client";

import { useGAUserTracking } from "lib/hooks/useGAUserTracking";

export default function GAUserTracker() {
  // Initialize GA4 user tracking
  useGAUserTracking();

  // This component renders nothing, it only handles side effects
  return null;
}
